module.exports = __webpack_public_path__ + "static/img/10.745dafd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zddcf/10.png
// module id = 49dS
// module chunks = 0